import { createPaginatedKey } from "api/keys";

export const indexesKeys = {
  indexesFulfillment: createPaginatedKey("indexesFulfillment"),
};
